import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { SolutionCardComponent } from './components/solution-card/solution-card.component';
import { CommonModule } from '@angular/common';
import { AsyncState, getData, getError } from '../../shared/models/async-state';
import { ErrorStateComponent } from '../../shared/components/error-state.component';
import { EmptyStateComponent } from '../../shared/components/empty-state.component';
import { LoadingSkeletonComponent } from '../../shared/components/loading-skeleton.component';
import { Period, PERIOD_DISPLAY_LABELS } from '../../core/constants/periods';
import { SolutionWithProducts } from './models/solutions.types';

@Component({
  selector: 'app-solutions',
  imports: [SolutionCardComponent, CommonModule, LoadingSkeletonComponent, ErrorStateComponent, EmptyStateComponent],
  templateUrl: './solutions.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SolutionsComponent {
  readonly dataState = input.required<AsyncState<SolutionWithProducts[]>>();
  readonly selectedPeriod = input<Period>('DAY');
  readonly retry = output<void>();

  readonly data = computed(() => getData(this.dataState()) ?? []);
  readonly error = computed(() => getError(this.dataState()));

  readonly selectedPeriodLabel = computed(() => {
    return PERIOD_DISPLAY_LABELS[this.selectedPeriod()];
  });

  readonly isEmpty = computed(() => {
    return getData(this.dataState()) && this.data().length === 0;
  });

  onRetry(): void {
    this.retry.emit();
  }
}
